export default [
  {
    width: 25,
    header: {
      type: 'text',
      caption: 'Name',
    },
    cell: {
      type: 'slot',
      name: 'name',
    },
  },
  {
    width: 25,
    header: {
      type: 'text',
      caption: 'Description',
    },
    cell: {
      type: 'slot',
      name: 'description',
    },
  },
];
